import React, { useEffect, useState } from 'react';
import { getAssignDeviceInfo } from '../../../../services/api_collection';
import { useLocation } from 'react-router-dom';
import DetailsBox from '../../../hms/details/components/DetailsBox';
import { toast } from 'react-toastify';
import { OfficialIdsStyle } from '../ViewEmployeeStyle';

const DeviceInfo = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [deviceDetailsList, setDeviceDetailsList] = useState([]);

  const formatDeviceData = (device) => {
    const fields = [
      { key: 'Device Type', prop: 'device_type' },
      { key: 'Device Id', prop: 'device_id' },
      { key: 'Brand', prop: 'brand' },
      { key: 'CPU', prop: 'cpu' },
      { key: 'RAM', prop: 'ram' },
      { key: 'Storage', prop: 'storage' },
      { key: 'Graphics', prop: 'graphics' },
      { key: 'Operating System', prop: 'operating_system' },
      { key: 'MAC Address', prop: 'macORip_address' },
      { key: 'Username', prop: 'user_name' },
      { key: 'Password', prop: 'password', isPassword: true }
    ];

    return fields
      .filter(
        ({ prop }) =>
          device?.[prop] !== undefined && device?.[prop] !== null && device?.[prop] !== ''
      )
      .map(({ key, prop, isPassword }) => ({
        key,
        value: device[prop],
        ...(isPassword ? { isPassword } : {})
      }));
  };

  const handleGetDeviceDetails = async () => {
    setLoading(true);
    try {
      const res = await getAssignDeviceInfo(id);
      if (res?.statusCode === 200 && Array.isArray(res?.data)) {
        const formattedDevices = res.data.map((item) => item?.device).filter(Boolean);
        setDeviceDetailsList(formattedDevices);
      } else {
        setDeviceDetailsList([]);
        toast.error(res?.message || 'No device data found');
      }
    } catch (err) {
      toast.error(err?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetDeviceDetails();
  }, [id]);

  if (deviceDetailsList?.length === 0) {
    return null;
  }

  return (
    <OfficialIdsStyle>
      <div className="title">
        <h5>Assign Devices</h5>
      </div>
      {deviceDetailsList.length > 0 &&
        deviceDetailsList.map((device, index) => (
          <DetailsBox
            key={index}
            heading={device?.device_id}
            cols={3}
            data={formatDeviceData(device)}
            loading={loading}
          />
        ))}
    </OfficialIdsStyle>
  );
};

export default DeviceInfo;
